import { connect } from 'react-redux'
import at from 'lodash/at'

import {
  getIssue,
  updateIssue,
  markIssueAsResolved
} from '../../actions/issues'

import IssueDetails from '../../components/issues/issue-details'
import { loadLocationIssuesCount } from '../../actions/auth'

function mapStateToProps (state, ownProps) {
  const issue = state.issues[ownProps.params.issueId]

  if (!issue) return { loading: true }

  const area = state.areas[issue.area]
  const issueDescription = state.issueDescriptions[issue.issueDescription]
  const submittedBy = state.users[issue.submittedBy]
  const services = at(state.services, issue.services || [])
  const resolvedBy = state.users[issue.resolvedBy]

  let latestHistory, latestUpdatedBy

  if (issue.latestHistory) {
    latestHistory = state.issueHistories[issue.latestHistory]
    latestUpdatedBy = state.users[latestHistory.updatedBy]
  }

  return {
    issue,
    area,
    issueDescription,
    submittedBy,
    services,
    latestHistory,
    latestUpdatedBy,
    resolvedBy
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(getIssue(ownProps.params.issueId))

  return {
    onMarkAsResolved () {
      dispatch(markIssueAsResolved(ownProps.params.issueId)).
        then(() => dispatch(loadLocationIssuesCount()))
    },

    onMarkAsPermanent () {
      dispatch(updateIssue(ownProps.params.issueId, { status: 'permanent' })).
        then(() => dispatch(loadLocationIssuesCount()))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueDetails)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-details-container.js